import React, { useEffect, useState } from 'react';

export default function ListPager({
  changeLimit,
  nextPage,
  prevPage,
  setPagerIndex,
  totalEvents,
  pagerIndex,
  limit,
  totalPages,
  paginatedItemCount
}) {
  const [isEnd, setEnd] = useState(false);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (pagerIndex === totalPages - 1) setEnd(true);
  }, [pagerIndex]);

  useEffect(() => {
    paginatedItemCount < limit ? setHide(true) : setHide(false);
  }, [paginatedItemCount]);

  return (
    <section className="section u--margin-bottom-50">
      <div className="pagination__section">
        <div className="container container--xl">
          <div className="grid grid--std">
            <div className="grid__col-xs-12">
              <div className="pagination__container">
                <nav>
                  <ul className="pagination pagination--md">
                    {pagerIndex !== 0 && (
                      <li className="pagination__item">
                        <a
                          onClick={() => {
                            prevPage();
                          }}
                        >
                          <i className="icon-arrow2-left-blue"></i>Prev
                        </a>
                      </li>
                    )}
                    {pagerIndex >= 1 && (
                      <li
                        onClick={() => {
                          setPagerIndex(0);
                        }}
                        className="pagination__item"
                      >
                        <a>1</a>
                      </li>
                    )}
                    {pagerIndex > 1 && (
                      <li className="pagination__item">
                        <a
                          onClick={() => {
                            const newIndex = pagerIndex - 1;
                            setPagerIndex(newIndex);
                          }}
                        >
                          {pagerIndex}
                        </a>
                      </li>
                    )}

                    <li className="pagination__item pagination__item--active">
                      <a href="#">{pagerIndex + 1}</a>
                    </li>
                    {pagerIndex !== totalPages - 2 && (
                      <li
                        className={`pagination__item ${
                          isEnd || hide ? 'u--hidden' : ''
                        }`}
                      >
                        <a
                          onClick={() => {
                            const newIndex = pagerIndex + 1;
                            setPagerIndex(newIndex);
                          }}
                        >
                          {pagerIndex + 2}
                        </a>
                      </li>
                    )}

                    {pagerIndex + 1 !== totalPages && (
                      <li className="pagination__item">
                        <a
                          onClick={() => {
                            const newIndex = totalPages - 1;
                            setPagerIndex(newIndex);
                          }}
                        >
                          {totalPages}
                        </a>
                      </li>
                    )}

                    {pagerIndex !== totalPages - 1 && (
                      <li className="pagination__item">
                        <a
                          onClick={() => {
                            nextPage();
                          }}
                        >
                          Next<i className="icon-arrow-right-blue"></i>
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>

                <div className="pagination__results-per-page">
                  <div className="pagination__results-label">
                    Results per page:
                  </div>
                  <div className="pagination__results-input-wrapper">
                    <select
                      onChange={(e) => {
                        changeLimit(e.target.value);
                      }}
                      className="pagination__results-input"
                    >
                      <option value="6">6</option>
                      <option value="12">12</option>
                      <option value="18">18</option>
                      <option value="24">24</option>
                      <option value="30">30</option>
                    </select>
                    <i className="icon-caret-down"></i>
                  </div>
                </div>
              </div>
              <div className="pagination__current-results">
              {pagerIndex === 0
                ? `Showing ${paginatedItemCount + 2} of ${totalEvents} Results`
                : `Showing ${paginatedItemCount} of ${totalEvents} Results`
              }
              </div>
            </div>
            <div className="grid__col-lg-4"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
